import React from 'react';
import "../template-file-css/document-file-template.css";


export const GHP_IFIBPS = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GHP_IFIBPS' className='file-pdf-document'>
            <div className='file-template'>


                <table>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">Birth Order</span>
                            <input type="text" id="txtBirthOrder" name="txtBirthOrder" className="add-only" />

                        </td>
                        <td className="w-375">
                            <span className="eleHeader">School/Grade</span>
                            <input type="text" id="txtSchool" name="txtSchool" className=" add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">Referral Source Name</span>
                            <input type="text" id="txtReferralName" name="txtReferralName" className=" add-only" />
                        </td>
                        <td className="w-375">
                            <span className="eleHeader">Contact Info</span>
                            <input type="text" id="txtContactInfo" name="txtContactInfo" className=" add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">Informant(s) Name and relationship to Individual</span>
                            <input type="text" id="txtInformant" name="txtInformant" className=" add-only" />
                        </td>
                        <td className="w-375">
                            <span className="eleHeader">Guardian/Caretaker</span>
                            <input type="text" id="txtGuardianCaretaker" name="txtGuardianCaretaker" className=" add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">Father Name</span>
                            <input type="text" id="txtFatherName" name="txtFatherName" className=" add-only" />
                        </td>
                        <td className="w-375">
                            <span className="eleHeader">Mother Name</span>
                            <input type="text" id="txtMotherName" name="txtMotherName" className=" add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">Telephone #</span>
                            <input type="text" id="txtTelephone" name="txtTelephone" className=" add-only" />
                        </td>
                        <td className="w-375">
                            <span className="eleHeader">Emergency Contact Name</span>
                            <input type="text" id="txtEmergencyContactName" name="txtEmergencyContactName" className=" add-only" />
                        </td>
                    </tr>
                </table>
                <h3>No Insurance Individuals Only</h3>
                <table>
                    <tr>
                        <td className="w-600"><span className="eleHeader">&nbsp;</span></td>
                        <td className="w-75" ><span className="eleHeader">Yes</span></td>
                        <td className="w-75"><span className="eleHeader">No</span></td>
                    </tr>
                    <tr>
                        <td className="w-600">
                            Have you applied for Medicaid or PeachCare for Kids in the last 60 days?
                        </td>
                        <td className="w-75 text-center">
                            <input type="radio" id="rbApppliedForMedicaid_Yes" name="rbApppliedForMedicaid" className="add-only" value="Yes" />
                        </td>
                        <td className="w-75 text-center">
                            <input type="radio" id="rbApppliedForMedicaid_No" name="rbApppliedForMedicaid" className="add-only" value="No" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-600">
                            Have you been denied for Medicaid or PeachCare for Kids in the last 60 days?
                        </td>
                        <td className="w-75 text-center">
                            <input type="radio" id="rbDeniedForMedicaid_Yes" name="rbDeniedForMedicaid" className="add-only" value="Yes" />
                        </td>
                        <td className="w-75 text-center">
                            <input type="radio" id="rbDeniedForMedicaid_No" name="rbDeniedForMedicaid" className="add-only" value="No" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-600">
                            Did assessor provide family with Medicaid Application and packet?
                        </td>
                        <td className="w-75 text-center">
                            <input type="radio" id="rbMedicaidApplicationPacket_Yes" name="rbMedicaidApplicationPacket" className="add-only" value="Yes" />
                        </td>
                        <td className="w-75 text-center">
                            <input type="radio" id="rbMedicaidApplicationPacket_No" name="rbMedicaidApplicationPacket" className="add-only" value="No" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-600">
                            Did family agree to complete Medicaid Application?
                        </td>
                        <td className="w-75 text-center">
                            <input type="radio" id="rbMedicaidApplication_Yes" name="rbMedicaidApplication" className="add-only" value="Yes" />
                        </td>
                        <td className="w-75 text-center">
                            <input type="radio" id="rbMedicaidApplication_No" name="rbMedicaidApplication" className="add-only" value="No" />
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className="eleHeader">Reason for Assessment/Presenting Problems</span>
                    <span className="small block">(Specific statements of mental health symptoms; frequency, intensity, and duration of conduct and behaviors,
                        clinical symptoms, and behaviors and concerns that would justify a referral for services; identify history of presenting problem, history of mental health services)</span>
                    <textarea id="txtReasonForAssessment" name="txtReasonForAssessment" className="add-only "></textarea>

                </p>

                <h3>Household Composition</h3>
                <table>
                    <tr>
                        <td className="w-200">
                            <span className="eleHeader w-200;">Name</span>
                        </td>
                        <td className="w-180">
                            <span className="eleHeader w-180;">Relationship</span>
                        </td>
                        <td className="w-150">
                            <span className="eleHeader w-150;">DOB or Age</span>
                        </td>
                        <td className="w-220">
                            <span className="eleHeader w-220;">Occupation</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-200">
                            <input type="text" id="txtName_1" name="txtName_1" className="add-only" />
                        </td>
                        <td className="w-180">
                            <input type="text" id="txtRelationship_1" name="txtRelationship_1" className="add-only" />
                        </td>
                        <td className="w-150">
                            <input type="date" id="txtDOB_1" name="txtDOB_1" className="add-only" />
                        </td>
                        <td className="w-220">
                            <input type="text" id="txtOccupation_1" name="txtOccupation_1" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-200">
                            <input type="text" id="txtName_2" name="txtName_2" className="add-only" />
                        </td>
                        <td className="w-180">
                            <input type="text" id="txtRelationship_2" name="txtRelationship_2" className="add-only" />
                        </td>
                        <td className="w-150">
                            <input type="date" id="txtDOB_2" name="txtDOB_2" className="add-only" />
                        </td>
                        <td className="w-220">
                            <input type="text" id="txtOccupation_2" name="txtOccupation_2" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-200">
                            <input type="text" id="txtName_3" name="txtName_3" className="add-only" />
                        </td>
                        <td className="w-180">
                            <input type="text" id="txtRelationship_3" name="txtRelationship_3" className="add-only" />
                        </td>
                        <td className="w-150">
                            <input type="date" id="txtDOB_3" name="txtDOB_3" className="add-only" />
                        </td>
                        <td className="w-220">
                            <input type="text" id="txtOccupation_3" name="txtOccupation_3" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-200">
                            <input type="text" id="txtName_4" name="txtName_4" className="add-only" />
                        </td>
                        <td className="w-180">
                            <input type="text" id="txtRelationship_4" name="txtRelationship_4" className="add-only" />
                        </td>
                        <td className="w-150">
                            <input type="date" id="txtDOB_4" name="txtDOB_4" className="add-only" />
                        </td>
                        <td className="w-220">
                            <input type="text" id="txtOccupation_4" name="txtOccupation_4" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-200">
                            <input type="text" id="txtName_5" name="txtName_5" className="add-only" />
                        </td>
                        <td className="w-180">
                            <input type="text" id="txtRelationship_5" name="txtRelationship_5" className="add-only" />
                        </td>
                        <td className="w-150">
                            <input type="date" id="txtDOB_5" name="txtDOB_5" className="add-only" />
                        </td>
                        <td className="w-220">
                            <input type="text" id="txtOccupation_5" name="txtOccupation_5" className="add-only" />
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className="eleHeader">Living Situation</span>
                    <span className="small block">(Check all that apply)</span>

                </p>
                <table>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbHowFamily" name="cbHowFamily_1" value="1" className="add-only" />
                            Home w/family
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbIndependentLiving" name="cbIndependentLiving_1" value="1" className="add-only" />
                            Independent Living
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbRiskHomelessness" name="cbRiskHomelessness_1" value="1" className="add-only" />
                            Risk of Homelessness
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbHomeless" name="cbHomeless_1" value="1" className="add-only" />
                            Homeless
                        </td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbAdequateHousing" name="cbAdequateHousing_1" value="1" className="add-only" />
                            Adequate Housing
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbSafetyRisk" name="cbSafetyRisk_1" value="1" className="add-only" />
                            Safety Risks/Hazardous
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbOvercrowded" name="cbOvercrowded_1" value="1" className="add-only" />
                            Overcrowded
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbGroupHome" name="cbGroupHome_1" value="1" className="add-only" />
                            Group Home/Foster Home
                        </td>
                    </tr>
                </table>
                <h3>Medical Screening/ Whole Health History</h3>
                <table>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader w-375;">Current Height</span>
                            <input type="text" id="txtCurrentHeight" name="txtCurrentHeight" className="add-only " />
                        </td>
                        <td className="w-375">
                            <span className="eleHeader w-375;">Current Weight</span>
                            <input type="text" id="txtCurrentWeight" name="txtCurrentWeight" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">Medical Exam</span>
                            <input type="checkbox" id="cbMedical_NoneReported" name="cbMedical_NoneReported1" value="1" className="add-only" /> None Reported
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">Date:
                            <input type="date" id="txtMedical_Date" name="txtMedical_Date" className="add-only" />
                        </td>
                        <td className="w-375">PCP name and location:
                            <input type="text" id="txtMedical_Location" name="txtMedical_Location" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">Dental Exam</span>
                            <input type="checkbox" id="cbDental_NoneReported" name="cbDental_NoneReported1" value="1" className="add-only" /> None Reported
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">Date:
                            <input type="date" id="txtDental_Date" name="txtDental_Date" className="add-only" />
                        </td>
                        <td className="w-375">DMD name and location:
                            <input type="text" id="txtDental_Location" name="txtDental_Location" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">Vision Exam</span>
                            <input type="checkbox" id="cbVision_NoneReported" name="cbVision_NoneReported1" value="1" className="add-only" /> None Reported
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">Date:
                            <input type="date" id="txtVision_Date" name="txtVision_Date" className="add-only" />
                        </td>
                        <td className="w-375">Optometrist name and location:
                            <input type="text" id="txtVision_Location" name="txtVision_Location" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">Psychological Evaluation</span>
                            <input type="checkbox" id="cbPsychological_NoneReported" name="cbPsychological_NoneReported1" value="1" className="add-only" /> None Reported
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">Date:
                            <input type="date" id="txtPsychological_Date" name="txtPsychological_Date" className="add-only" />
                        </td>
                        <td className="w-375">Provider name and location:
                            <input type="text" id="txtPsychological_Location" name="txtPsychological_Location" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">Psychiatric Evaluation/Follow-up</span>
                            <input type="checkbox" id="cbPsychiatric_NoneReported" name="cbPsychiatric_NoneReported1" value="1" className="add-only" /> None Reported
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">Date:
                            <input type="date" id="txtPsychiatric_Date" name="txtPsychiatric_Date" className="add-only" />
                        </td>
                        <td className="w-375">Provider name and location:
                            <input type="text" id="txtPsychiatric_Location" name="txtPsychiatric_Location" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">Medical complaints</span>
                            <td className="w-200">
                                <input type="radio" id="rbMedicalC_NoneReported" name="rbMedicalC" value="None Reported" className="add-only" /> None Reported
                            </td>
                            <td className="w-250 text-right">
                                <input type="radio" id="rbMedicalC_Current" name="rbMedicalC" value="Current complaints" className="add-only" /> Current complaints:
                            </td>
                            <td className="w-300">
                                <input type="text" id="txtCurrenComplaint" name="txtCurrenComplaint" className="add-only" />
                            </td>
                        </td>
                    </tr>
                </table>
                <tr>
                    <td className='w-750'>
                        <h4>Current Medications</h4>
                    </td>
                </tr>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbCurrentMedication_NoneReported" name="cbCurrentMedication_NoneReported1" value="1" className="add-only" /> None Reported
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className="eleHeader">Medication Name</span> </td>
                        <td className='w-150'> <span className="eleHeader">Dose/ Frequency</span> </td>
                        <td className='w-150'> <span className="eleHeader">Prescribed by</span> </td>
                        <td className='w-150'> <span className="eleHeader"> Next Refill</span> </td>
                        <td className='w-150'> <span className="eleHeader">Takes medication as prescribed?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtMedicationName_1" name="txtMedicationName_1" className="add-only" />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDose_1" name="txtDose_1" className="add-only" />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtPrescribedBy_1" name="txtPrescribedBy_1" className="add-only" />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtNextRefill_1" name="txtNextRefill_1" className="add-only" />
                        </td>

                        <td className='w-75  text-center'>
                            <input type="radio" id="rbTakesMedication_1_Yes" name="rbTakesMedication_1" className="add-only" value="Yes" /> Yes
                        </td>

                        <td className='w-75  text-center'>
                            <input type="radio" id="rbTakesMedication_1_No" name="rbTakesMedication_1" className="add-only" value="No" /> No
                        </td>

                    </tr>
                    <tr>
                        <td className="w-150" >
                            <input type="text" id="txtMedicationName_2" name="txtMedicationName_2" className="add-only" />
                        </td>
                        <td className="w-150">
                            <input type="text" id="txtDose_2" name="txtDose_2" className="add-only" />
                        </td>
                        <td className="w-150">
                            <input type="text" id="txtPrescribedBy_2" name="txtPrescribedBy_2" className="add-only" />
                        </td>
                        <td className="w-150">
                            <input type="text" id="txtNextRefill_2" name="txtNextRefill_2" className="add-only" />
                        </td>
                        <td className="w-75 text-center">
                            <input type="radio" id="rbTakesMedication_2_Yes" name="rbTakesMedication_2" className="add-only" value="Yes" />
                            Yes
                        </td>
                        <td className="w-75 text-center">
                            <input type="radio" id="rbTakesMedication_2_No" name="rbTakesMedication_2" className="add-only" value="No" />
                            No
                        </td>
                    </tr>
                    <tr>
                        <td className="w-150">
                            <input type="text" id="txtMedicationName_3" name="txtMedicationName_3" className="add-only" />
                        </td>
                        <td className="w-150">
                            <input type="text" id="txtDose_3" name="txtDose_3" className="add-only" />
                        </td>
                        <td className="w-150">
                            <input type="text" id="txtPrescribedBy_3" name="txtPrescribedBy_3" className="add-only" />
                        </td>
                        <td className="w-150">
                            <input type="text" id="txtNextRefill_3" name="txtNextRefill_3" className="add-only" />
                        </td>
                        <td className='w-75 text-center'>
                            <input type="radio" id="rbTakesMedication_3_Yes" name="rbTakesMedication_3" className="add-only" value="Yes" />
                            Yes
                        </td>
                        <td className="w-75 text-center">
                            <input type="radio" id="rbTakesMedication_3_No" name="rbTakesMedication_3" className="add-only" value="No" />
                            No
                        </td>
                    </tr>
                    <tr>
                        <td className="w-150">
                            <input type="text" id="txtMedicationName_4" name="txtMedicationName_4" className="add-only" />
                        </td>
                        <td className="w-150">
                            <input type="text" id="txtDose_4" name="txtDose_4" className="add-only" />
                        </td>
                        <td className="w-150">
                            <input type="text" id="txtPrescribedBy_4" name="txtPrescribedBy_4" className="add-only" />
                        </td>
                        <td className="w-150">
                            <input type="text" id="txtNextRefill_4" name="txtNextRefill_4" className="add-only" />
                        </td>
                        <td className="w-75 text-center">
                            <input type="radio" id="rbTakesMedication_4_Yes" name="rbTakesMedication_4" className="add-only" value="Yes" />
                            Yes
                        </td>
                        <td className="w-75 text-center">
                            <input type="radio" id="rbTakesMedication_4_No" name="rbTakesMedication_4" className="add-only" value="No" />
                            No
                        </td>
                    </tr>
                    <tr>
                        <td className="w-150">
                            <input type="text" id="txtMedicationName_5" name="txtMedicationName_5" className="add-only" />
                        </td>
                        <td className="w-150">
                            <input type="text" id="txtDose_5" name="txtDose_5" className="add-only" />
                        </td>
                        <td className="w-150">
                            <input type="text" id="txtPrescribedBy_5" name="txtPrescribedBy_5" className="add-only" />
                        </td>
                        <td className="w-150">
                            <input type="text" id="txtNextRefill_5" name="txtNextRefill_5" className="add-only" />
                        </td>
                        <td className="w-75 text-center">
                            <input type="radio" id="rbTakesMedication_5_Yes" name="rbTakesMedication_5" className="add-only" value="Yes" />
                            Yes
                        </td>
                        <td className="w-75 text-center">
                            <input type="radio" id="rbTakesMedication_5_No" name="rbTakesMedication_5" className="add-only" value="No" />
                            No
                        </td>
                    </tr>
                    <tr>
                        <td className="w-150">
                            <input type="text" id="txtMedicationName_6" name="txtMedicationName_6" className="add-only" />
                        </td>
                        <td className="w-150">
                            <input type="text" id="txtDose_6" name="txtDose_6" className="add-only" />
                        </td>
                        <td className="w-150">
                            <input type="text" id="txtPrescribedBy_6" name="txtPrescribedBy_6" className="add-only" />
                        </td>
                        <td className="w-150">
                            <input type="text" id="txtNextRefill_6" name="txtNextRefill_6" className="add-only" />
                        </td>
                        <td className="w-75 text-center">
                            <input type="radio" id="rbTakesMedication_6_Yes" name="rbTakesMedication_6" className="add-only" value="Yes" />
                            Yes
                        </td>
                        <td className="w-75 text-center">
                            <input type="radio" id="rbTakesMedication_6_No" name="rbTakesMedication_6" className="add-only" value="No" />
                            No
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className="eleHeader">Past Medications</span>
                    <tr>
                        <td className='w-200'>
                            <input type="radio" id="rbPastMedication_None" name="rbPastMedication" className="add-only" value="None Reported" /> None Reported
                        </td>
                        <td className='w-550'>
                            <input type="radio" id="rbPastMedication_Medication" name="rbPastMedication" className="add-only" value="Past medications" /> Past medications (include dosage, prescribing doctor, purpose, and duration)
                        </td>
                    </tr>
                    <textarea id="txtPastMedications" name="txtPastMedications" className="add-only"></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Mental Health/Psychiatric History</span>
                    <span className="small block">(include history of counseling, dates, reason, and outcomes)</span>
                </p>
                <p className="w-750">
                    <tr>
                        <td className='w-200'>
                            <input type="radio" id="rbMental_None" name="rbMental" className="add-only" value="None Reported" /> None Reported
                        </td>
                        <td className='w-550'>
                            <input type="radio" id="rbMental_NameOfProvider" name="rbMental" className="add-only" value="Name of provider" /> Name of provider, duration of treatment, diagnosis, date, issues
                        </td>
                    </tr>
                    <textarea id="txtMental" name="txtMental" className="add-only"></textarea>
                </p>
                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;"># of inpatient/psychiatric hospitalizations in 90 days</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtInpatient" name="txtInpatient" className=" add-only" />
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbInpatient_None" name="cbInpatient_None1" className="add-only" value="1" /> None Reported
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className="eleHeader">Eating Patterns</span>
                    <span className="small block">(eating disorders, appetite abnormal eating patterns, recently gained or lost weight)</span>
                    <textarea id="txtEatingPatterns" name="txtEatingPatterns" className="add-only "></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Sleeping Patterns</span>
                    <span className="small block">(insomnia, hypersomnia, abnormal sleeping patterns, sleep disorders)</span>
                    <textarea id="txtSleepingPatters" name="txtSleepingPatters" className="add-only "></textarea>

                </p>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className="eleHeader">Exercise Patterns</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="radio" id="rbExercise_None" name="rbExercise" className="add-only" value="None Reported" /> None Reported
                        </td>
                        <td className='w-250 text-right'>
                            <input type="radio" id="rbExercise_Frequency" name="rbExercise" className="add-only" value="Frequency and type" /> Frequency and type:
                        </td>
                        <td className='w-300'>
                            <input type="text" id="txtFrequencyType" name="txtFrequencyType" className="add-only " />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className="eleHeader w-750;">Allergies</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="checkbox" id="cbAllergies_None" name="cbAllergies_None1" className="add-only" value="1" /> None Reported
                        </td>

                    </tr>
                    <tr>
                        <td className="w-120 ">
                            <input type="checkbox" id="cbAllergies_Medication" name="cbAllergies_Medication1" className="add-only" value="1" /> Medication:
                        </td>
                        <td className="w-250">
                            <input type="text" id="txtAllegies_Medication" name="txtAllegies_Medication" className="add-only" />
                        </td>

                    </tr>
                    <tr>
                        <td className='w-75'>
                            <input type="checkbox" id="cbAllegies_Food" name="cbAllegies_Food1" className="add-only" value="1" /> Food:
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtAllegies_Food" name="txtAllegies_Food" className="add-only" />
                        </td>

                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbAllergies_Pets" name="cbAllergies_Pets1" className="add-only" value="1" /> Seasonal/Pets:
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtAllegies_Pets" name="txtAllegies_Pets" className="add-only" />
                        </td>
                    </tr>

                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className="eleHeader w-750;">Assistive or Adaptive Devices</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbAssistive_None" name="cbAssistive_None1" className="add-only" value="1" />
                            None Reported
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbAssistive_HearingAids" name="cbAssistive_HearingAids1" className="add-only" value="1" />
                            Hearing Aids
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbAssistive_Glasses" name="cbAssistive_Glasses1" className="add-only" value="1" />
                            Glasses
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbAssistive_Translated" name="cbAssistive_Translated1" className="add-only" value="1" />
                            Translated written information
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbAssistive_Cane" name="cbAssistive_Cane1" className="add-only" value="1" />
                            Cane
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbAssistive_Translator" name="cbAssistive_Translator1" className="add-only" value="1" />
                            Translator for speaking
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbAssistive_Walker" name="cbAssistive_Walker1" className="add-only" value="1" />
                            Walker
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbAssistive_Crutches" name="cbAssistive_Crutches1" className="add-only" value="1" />
                            Crutches
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbAssistive_Braille" name="cbAssistive_Braille1" className="add-only" value="1" />
                            Braille
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbAssistive_Wheelchair" name="cbAssistive_Wheelchair1" className="add-only" value="1" />
                            Wheelchair
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbAssistive_Other" name="cbAssistive_Other1" className="add-only" value="1" />
                            Other:
                            <input type="text" id="txtAssistive_Other" name="txtAssistive_Other" className="add-only" />
                        </td>
                    </tr>
                </table>
                <h3>Family History</h3>

                <p className="w-750">
                    <span className="eleHeader">Medical problems</span>
                    <span className="small block">(Heart Disease, Lung Disease, Cancer, Strokes, Dementia, Diabetes, Asthma)</span>
                    <input type="radio" id="rbMedicalP_Nonereported" name="rbMedicalP" className="add-only" value="None Reported" /> None Reported
                    &nbsp;
                    <input type="radio" id="rbMedicalP_SpecifyPerson" name="rbMedicalP" className="add-only" value="Specify person and problem" /> Specify person and problem
                    <textarea id="txtMedicalProblem" name="txtMedicalProblem" className="add-only "></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Substance abuse</span>
                    <span className="small block">(Alcohol, Cocaine, Cannabis, Stimulants, Inhalants, Hallucinogens, Sedatives, Designer Drugs)</span>
                    <input type="radio" id="rbSubstance_Nonereported" name="rbSubstance" className="add-only" value="None Reported" /> None Reported
                    &nbsp;
                    <input type="radio" id="rbSubstance_SpecifyPerson" name="rbSubstance" className="add-only" value="Specify person and problem" /> Specify person and problem
                    <textarea id="txtSubstanceAbuse" name="txtSubstanceAbuse" className="add-only "></textarea>

                </p>

                <p className="w-750">
                    <span className="eleHeader">Mental Illness</span>
                    <span className="small block">(Depression, Schizophrenia, Bipolar disorder, Anxiety, Aadd-only, ADHD, Learning Disorders, School Behavior Problems, Incarcerations, Gambling)</span>
                    <input type="radio" id="rbMentalIllness_Nonereported" name="rbMentalIllness" className="add-only" value="None Reported" /> None Reported
                    &nbsp;
                    <input type="radio" id="rbMentalIllness_SpecifyPerson" name="rbMentalIllness" className="add-only" value="Specify person and problem" /> Specify person and problem
                    <textarea id="txtMentalIllness" name="txtMentalIllness" className="add-only "></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Family Dynamics</span>
                    <span className="small block">(include history of relationships; history of guardians; how problems have been handled; siblings; relationships with both biological parents; safety issues; domestic violence; custody and abuse)</span>
                    <textarea id="txtFamilyDynamics" name="txtFamilyDynamics" className="add-only "></textarea>

                </p>


                <h3>DFCS/DJJ Involvement</h3>

                <p className="w-750">
                    <span className="eleHeader">Past or current involvement with DFCS</span>
                    <span className="small block">(include dates, reason, resolution)</span>
                    <input type="radio" id="rbDFCS_Nonereported" name="rbDFCS" className="add-only" value="None Reported" /> None Reported &nbsp;
                    <input type="radio" id="rbDFCS_Past" name="rbDFCS" className="add-only" value="Past" /> Past &nbsp;
                    <input type="radio" id="rbDFCS_Current" name="rbDFCS" className="add-only" value="Current" /> Current
                    <textarea id="txtDFCS" name="txtDFCS" className="add-only "></textarea>

                </p>


                <p className="w-750">
                    <span className="eleHeader">DFCS Worker Name and Number</span>
                    <input type="text" id="txtDFCSWorker" name="txtDFCSWorker" className="add-only " />

                </p>
                <p className="w-750">
                    <span className="eleHeader">Is there a reunification plan?</span>
                    <input type="radio" id="rbPlan_No" name="rbPlan" className="add-only" value="No" /> No
                    &nbsp;
                    <input type="radio" id="rbPlan_Yes" name="rbPlan" className="add-only" value="Yes" />
                    Yes (provide potential date of reunification and person that individual is scheduled to reunify with)
                    <textarea id="txtReunificationPlan" name="txtReunificationPlan" className="add-only "></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Past or current involvement with DJJ</span>
                    <span className="small block">(include dates, charges, incarcerations, probation)</span>
                    <input type="radio" id="rbDJJ_Nonereported" name="rbDJJ" className="add-only" value="None Reported" /> None Reported &nbsp;
                    <input type="radio" id="rbDJJ_Past" name="rbDJJ" className="add-only" value="Past" /> Past &nbsp;
                    <input type="radio" id="rbDJJ_Current" name="rbDJJ" className="add-only" value="Current" /> Current
                    <textarea id="txtDJJ" name="txtDJJ" className="add-only "></textarea>

                </p>

                <table>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader w-375;"># of arrests/charges in the last 90 days</span>
                            <input type="text" id="txtArrests" name="txtArrests" className="add-only " />
                        </td>
                        <td className="w-375">
                            <span className="eleHeader w-375;">Probation Officer Name and Number</span>
                            <input type="text" id="txtofficerName" name="txtofficerName" className="add-only " />
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className="eleHeader">Describe behavior management techniques utilized with child</span>
                    <span className="small block">(include the type of discipline and who is the primary disciplinarian, Individual reaction to discipline</span>
                    <textarea id="txtUtilizedWithChild" name="txtUtilizedWithChild" className="add-only "></textarea>

                </p>

                <h3>General Appearance</h3>
                <span className="small block">(during assessment)</span>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className="eleHeader w-750;">Appearance</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbWellGroomed" name="cbWellGroomed1" className="add-only" value="1" />
                            Well groomed
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbUnkempt" name="cbUnkempt1" className="add-only" value="1" />
                            Unkempt
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbDisheveled" name="cbDisheveled1" className="add-only" value="1" />
                            Disheveled
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMalodorous" name="cbMalodorous1" className="add-only" value="1" />
                            Malodorous
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbAppearance_Other" name="cbAppearance_Other1" className="add-only" value="1" />
                            Other:
                            <input type="text" id="txtAppearance_Other" name="txtAppearance_Other" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">Build</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbAverage" name="cbAverage1" className="add-only" value="1" />
                            Average
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbThin" name="cbThin1" className="add-only" value="1" />
                            Thin
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbOverweight" name="cbOverweight1" className="add-only" value="1" />
                            Overweight
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbUnderweight" name="cbUnderweight1" className="add-only" value="1" />
                            Underweight
                        </td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbObese" name="cbObese1" className="add-only" value="1" />
                            Obese
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">Demeanor</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbCooperative" name="cbCooperative1" className="add-only" value="1" />
                            Cooperative
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbHostile" name="cbHostile1" className="add-only" value="1" />
                            Hostile
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbGuarded" name="cbGuarded1" className="add-only" value="1" />
                            Guarded
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbWithdrawn" name="cbWithdrawn_1" className="add-only" value="1" />
                            Withdrawn
                        </td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbPreoccupied" name="cbPreoccupied_1" className="add-only" value="1" />
                            Preoccupied
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbDemanding" name="cbDemanding_1" className="add-only" value="1" />
                            Demanding
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbSeductive" name="cbSeductive_1" className="add-only" value="1" />
                            Seductive
                        </td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbDemeanor_Other" name="cbDemeanor_Other1" className="add-only" value="1" />
                            Other:
                            <input type="text" id="txtDemeanor_Other" name="txtDemeanor_Other" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">Speech</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbClear" name="cbClear_1" className="add-only" value="1" />
                            Clear
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbPressured" name="cbPressured_1" className="add-only" value="1" />
                            Pressured
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbSlurred" name="cbSlurred_1" className="add-only" value="1" />
                            Slurred
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbSoft" name="cbSoft_1" className="add-only" value="1" />
                            Soft
                        </td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbRapid" name="cbRapid_1" className="add-only" value="1" />
                            Rapid
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbLoud" name="cbLoud_1" className="add-only" value="1" />
                            Loud
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbSlow" name="cbSlow_1" className="add-only" value="1" />
                            Slow
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMonotone" name="cbMonotone_1" className="add-only" value="1" />
                            Monotone
                        </td>
                    </tr>
                    <tr>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbSpeech_Loud" name="cbSpeech_Loud1" className="add-only" value="1" />
                            Other:
                            <input type="text" id="txtSpeech_Loud" name="txtSpeech_Loud" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">Eye Contact</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbEye_Average" name="cbEye_Average_1" className="add-only" value="1" />
                            Average
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbDecreased" name="cbDecreased_1" className="add-only" value="1" />
                            Decreased
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbIncreased" name="cbIncreased_1" className="add-only" value="1" />
                            Increased
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbEye_Other" name="cbEye_Other1" className="add-only" value="1" />
                            Other:
                            <input type="text" id="txtEye_Other" name="txtEye_Other" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">Mood</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbEuthymic" name="cbEuthymic_1" className="add-only" value="1" />
                            Euthymic
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbEuphoriaElation" name="cbEuphoriaElation_1" className="add-only" value="1" />
                            Euphoria, Elation
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbAngerHostility" name="cbAngerHostility_1" className="add-only" value="1" />
                            Anger, Hostility
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbAnxietyFear" name="cbAnxietyFear_1" className="add-only" value="1" />
                            Anxiety, Fear, Apprehension
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbDysphoria" name="cbDysphoria_1" className="add-only" value="1" />
                            Dysphoria, Depression, Sadness
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbMood_Other" name="cbMood_Other1" className="add-only" value="1" />
                            Other:
                            <input type="text" id="txtMood_Other" name="txtMood_Other" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">Affect</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbAppropriate" name="cbAppropriate_1" className="add-only" value="1" />
                            Appropriate/Mood Congruent
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbFlat" name="cbFlat_1" className="add-only" value="1" />
                            Flat
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbBlunted" name="cbBlunted_1" className="add-only" value="1" />
                            Blunted
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbConstricted" name="cbConstricted_1" className="add-only" value="1" />
                            Constricted
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbLabile" name="cbLabile_1" className="add-only" value="1" />
                            Labile
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbInappropriate" name="cbInappropriate_1" className="add-only" value="1" />
                            Inappropriate/Incongruent
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbBright" name="cbBright_1" className="add-only" value="1" />
                            Bright
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbExpansive" name="cbExpansive_1" className="add-only" value="1" />
                            Expansive
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbAffect_Other" name="cbAffect_Other1" className="add-only" value="1" />
                            Other:
                            <input type="text" id="txtAffect_Other" name="txtAffect_Other" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader">Thought Content and Process</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbLogical" name="cbLogical_1" className="add-only" value="1" />
                            Logical
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbCoherent" name="cbCoherent_1" className="add-only" value="1" />
                            Coherent
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbGoalDirected" name="cbGoalDirected_1" className="add-only" value="1" />
                            Goal Directed
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <td className="w-250">
                                <input type="checkbox" id="cbPreoccupation" name="cbPreoccupation_1" className="add-only" value="1" />
                                Preoccupation
                            </td>
                            <td className="w-250">
                                <input type="checkbox" id="cbParanoia" name="cbParanoia_1" className="add-only" value="1" />
                                Paranoia
                            </td>
                            <td className="w-250">
                                <input type="checkbox" id="cbCompulsions" name="cbCompulsions_1" className="add-only" value="1" />
                                Compulsions
                            </td>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbObsessions" name="cbObsessions_1" className="add-only" value="1" />
                            Obsessions
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbDelusions" name="cbDelusions_1" className="add-only" value="1" />
                            Delusions
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbDepersonalization" name="cbDepersonalization_1" className="add-only" value="1" />
                            Depersonalization
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="checkbox" id="cbLoose" name="cbLoose_1" className="add-only" value="1" />
                            Loose Associations (illogical shifting between unrelated topics)
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="checkbox" id="cbCircumstantial" name="cbCircumstantial_1" className="add-only" value="1" />
                            Circumstantial (provide unnecessary detail)
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="checkbox" id="cbTangential" name="cbTangential_1" className="add-only" value="1" />
                            Tangential (move from thought to thought that relate but never get to the point)
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="checkbox" id="cbFlight" name="cbFlight_1" className="add-only" value="1" />
                            Flight of Ideas (quickly moving from one idea to another)
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="checkbox" id="cbWordSalad" name="cbWordSalad_1" className="add-only" value="1" />
                            Word Salad (randomly spoken words)
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="checkbox" id="cbThoughtBlocking" name="cbThoughtBlocking_1" className="add-only" value="1" />
                            Thought Blocking (thoughts are interrupted)
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="checkbox" id="cbPerseveration" name="cbPerseveration_1" className="add-only" value="1" />
                            Perseveration (repetition of words, phrases, or ideas)
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="checkbox" id="cbThought_Other" name="cbThought_Other1" className="add-only" value="1" />
                            Other:
                            <input type="text" id="txtThought_Other" name="txtThought_Other" className="add-only " />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">Judgement</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="radio" id="rbGood" name="rbJudgement" className="add-only" value="Good" /> Good
                        </td>
                        <td className="w-187">
                            <input type="radio" id="rbFair" name="rbJudgement" className="add-only" value="Fair" /> Fair
                        </td>
                        <td className="w-187">
                            <input type="radio" id="rbPoor" name="rbJudgement" className="add-only" value="Poor" /> Poor
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">Alert and Orientation</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbPerson" name="cbPerson_1" className="add-only" value="1" /> Person
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbPlace" name="cbPlace_1" className="add-only" value="1" /> Place
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbTime" name="cbTime_1" className="add-only" value="1" /> Time
                        </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbSituation" name="cbSituation_1" className="add-only" value="1" />
                            Situation
                        </td>
                    </tr>
                </table>
                <h3>Psycho-Social</h3>
                <span className="small block">(identify duration, intensity, frequency, access to weapons, dates, history, triggers, treatment)</span>

                <p className="w-750">
                    <span className="eleHeader">Suicidal Ideation</span>
                    <input type="radio" id="rbSuicidal_Nonereported" name="rbSuicidal" className="add-only" value="None Reported" /> None Reported &nbsp;
                    <input type="radio" id="rbSuicidal_Past" name="rbSuicidal" className="add-only" value="Past" /> Past &nbsp;
                    <input type="radio" id="rbSuicidal_Current" name="rbSuicidal" className="add-only" value="Current" /> Current (frequency, intensity, access to weapons, triggers)
                    <textarea id="txtSuicidal" name="txtSuicidal" className="add-only"></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Self-Mutilation/Cutting</span>
                    <input type="radio" id="rbCutting_Nonereported" name="rbCutting" className="add-only" value="None Reported" /> None Reported &nbsp;
                    <input type="radio" id="rbCutting_Past" name="rbCutting" className="add-only" value="Past" /> Past &nbsp;
                    <input type="radio" id="rbCutting_Current" name="rbCutting" className="add-only" value="Current" /> Current (frequency, intensity, access to weapons, triggers)
                    <textarea id="txtCutting" name="txtCutting" className="add-only "></textarea>

                </p>
                <p className="w-750">

                    <span className="eleHeader">Homicidal Ideation</span>
                    <input type="radio" id="rbHomicidal_Nonereported" name="rbHomicidal" className="add-only" value="None Reported" /> None Reported &nbsp;
                    <input type="radio" id="rbHomicidal_Past" name="rbHomicidal" className="add-only" value="Past" /> Past &nbsp;
                    <input type="radio" id="rbHomicidal_Current" name="rbHomicidal" className="add-only" value="Current" /> Current
                    (frequency, intensity, access to weapons, triggers, identified target)
                    <textarea id="txtHomicidal" name="txtHomicidal" className="add-only "></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Delusions/Hallucinations</span>
                    <input type="radio" id="rbDelusions_Nonereported" name="rbDelusions" className="add-only" value="None Reported" /> None Reported &nbsp;
                    <input type="radio" id="rbDelusions_Past" name="rbDelusions" className="add-only" value="Past" /> Past &nbsp;
                    <input type="radio" id="rbDelusions_Current" name="rbDelusions" className="add-only" value="Current" /> Current
                    (type of hallucination (visual, tactile, olfactory, auditory), frequency, triggers, type of delusion (persecutory, reference, grandiose, erotomaniac, somatic, control, bizarre, and non-bizarre)
                    <textarea id="txtDelusions" name="txtDelusions" className="add-only "></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Anxiety Symptoms</span>
                    <span className="small block">(phobia, panic, generalized anxiety, Obsessive Compulsive Disorder)</span>
                    <input type="radio" id="rbAnxiety_Nonereported" name="rbAnxiety" className="add-only" value="None Reported" /> None Reported &nbsp;
                    <input type="radio" id="rbAnxiety_Past" name="rbAnxiety" className="add-only" value="Past" /> Past &nbsp;
                    <input type="radio" id="rbAnxiety_Current" name="rbAnxiety" className="add-only" value="Current" /> Current &nbsp;
                    (frequency, triggers, severity)
                    <textarea id="txtAnxiety" name="txtAnxiety" className="add-only "></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">PTSD Symptoms</span>
                    <span className="small block">(terrors, nightmares, flashbacks, recurrent recollections, persistent avoidance of stressor, intrusive thoughts, startled response)</span>

                    <input type="radio" id="rbPTSD_Nonereported" name="rbPTSD" className="add-only" value="None Reported" /> None Reported &nbsp;
                    <input type="radio" id="rbPTSD_Past" name="rbPTSD" className="add-only" value="Past" /> Past &nbsp;
                    <input type="radio" id="rbPTSD_Current" name="rbPTSD" className="add-only" value="Current" /> Current
                    <textarea id="txtPTSD" name="txtPTSD" className="add-only"></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Temper Tantrums/Rapid Mood Swings</span>
                    <input type="radio" id="rbTemper_Nonereported" name="rbTemper" className="add-only" value="None Reported" /> None Reported &nbsp;
                    <input type="radio" id="rbTemper_Past" name="rbTemper" className="add-only" value="Past" /> Past &nbsp;
                    <input type="radio" id="rbTemper_Current" name="rbTemper" className="add-only" value="Current" /> Current
                    <textarea id="txtTemper" name="txtTemper" className="add-only"></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Depressive Symptoms</span>
                    <input type="radio" id="rbDepressive_Nonereported" name="rbDepressive" className="add-only" value="None Reported" /> None Reported &nbsp;
                    <input type="radio" id="rbDepressive_Past" name="rbDepressive" className="add-only" value="Past" /> Past &nbsp;
                    <input type="radio" id="rbDepressive_Current" name="rbDepressive" className="add-only" value="Current" /> Current
                    <textarea id="txtDepressive" name="txtDepressive" className="add-only"></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Aggressive Behavior</span>
                    <input type="radio" id="rbAggressive_Nonereported" name="rbAggressive" className="add-only" value="None Reported" /> None Reported &nbsp;
                    <input type="radio" id="rbAggressive_Specify" name="rbAggressive" className="add-only" value="Specify" /> Specify
                    <textarea id="txtAggressive" name="txtAggressive" className="add-only"></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Oppositional Behavior</span>
                    <input type="radio" id="rbOppositional_Nonereported" name="rbOppositional" className="add-only" value="None Reported" /> None Reported &nbsp;
                    <input type="radio" id="rbOppositional_Specify" name="rbOppositional" className="add-only" value="Specify" /> Specify
                    <textarea id="txtOppositional" name="txtOppositional" className="add-only "></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Bullying Behavior</span>
                    <span className="small block">(aggressor or victim, cyber, social, school)</span>
                    <input type="radio" id="rbBullying_Nonereported" name="rbBullying" className="add-only" value="None Reported" /> None Reported &nbsp;
                    <input type="radio" id="rbBullying_Past" name="rbBullying" className="add-only" value="Past" /> Past &nbsp;
                    <input type="radio" id="rbBullying_Current" name="rbBullying" className="add-only" value="Current" /> Current
                    <textarea id="txtBullying" name="txtBullying" className="add-only "></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Impulse Control Issues</span>
                    <span className="small block">(kleptomania, pyromania, intermittent explosive disorder, trichotillomania, gambling, issues with impulsive control)</span>

                    <input type="radio" id="rbImpulse_Nonereported" name="rbImpulse" className="add-only" value="None Reported" /> None Reported &nbsp;
                    <input type="radio" id="rbImpulse_Past" name="rbImpulse" className="add-only" value="Past" /> Past &nbsp;
                    <input type="radio" id="rbImpulse_Current" name="rbImpulse" className="add-only" value="Current" /> Current
                    <textarea id="txtImpulse" name="txtImpulse" className="add-only "></textarea>

                </p>


                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">Attention Deficit and Hyperactivity</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbAttention_NoneReported" name="cbAttention_NoneReported1" className="add-only" value="1" />
                            None Reported
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbLosingthings" name="cbLosingthings_1" className="add-only" value="1" />
                            Losing things
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbForgetting" name="cbForgetting_1" className="add-only" value="1" />
                            Forgetting things
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbImpulsivity" name="cbImpulsivity_1" className="add-only" value="1" />
                            Impulsivity
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbProblemsFinishing" name="cbProblemsFinishing1" className="add-only" value="1" />
                            Problems finishing tasks
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbBlurtingOut" name="cbBlurtingOut_1" className="add-only" value="1" />
                            Blurting out
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbInterrupting" name="cbInterrupting_1" className="add-only" value="1" />
                            Interrupting
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbImpatience" name="cbImpatience_1" className="add-only" value="1" />
                            Impatience
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbInattentiveness" name="cbInattentiveness1" className="add-only" value="1" />
                            Inattentiveness
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbDistractibility" name="cbDistractibility1" className="add-only" value="1" />
                            Distractibility
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbHyperactivity" name="cbHyperactivity1" className="add-only" value="1" />
                            Hyperactivity
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbFidgetiness" name="cbFidgetiness_1" className="add-only" value="1" />
                            Fidgetiness
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbProblemsSitting" name="cbProblemsSitting1" className="add-only" value="1" />
                            Problems sitting still
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className="eleHeader">Eating Disorders</span>
                    <span className="small block">(Anorexia Nervosa, Bulimia)</span>
                    <input type="radio" id="rbEating_Nonereported" name="rbEating" className="add-only" value="None Reported" /> None Reported &nbsp;
                    <input type="radio" id="rbEating_Past" name="rbEating" className="add-only" value="Past" /> Past &nbsp;
                    <input type="radio" id="rbEating_Current" name="rbEating" className="add-only" value="Current" /> Current
                    <textarea id="txtEating" name="txtEating" className="add-only "></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Sexual and Gender Identity Issues</span>
                    <input type="radio" id="rbSexual_Nonereported" name="rbSexual" className="add-only" value="None Reported" /> None Reported &nbsp;
                    <input type="radio" id="rbSexual_Past" name="rbSexual" className="add-only" value="Past" />  Past &nbsp;
                    <input type="radio" id="rbSexual_Current" name="rbSexual" className="add-only" value="Current" /> Current
                    <textarea id="txtSexual" name="txtSexual" className="add-only "></textarea>

                </p>

                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">Sexual Behavior</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbSexualBehavior_Nonereported" name="cbSexualBehavior_Nonereported1" className="add-only" value="1" />
                            None Reported
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbSexualPromiscuity" name="cbSexualPromiscuity1" className="add-only" value="1" />
                            Sexual promiscuity:
                            <input type="text" id="txtSexualPromiscuity" name="txtSexualPromiscuity" className="add-only" />
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbProstitution" name="cbProstitution_1" className="add-only" value="1" />
                            Prostitution:
                            <input type="text" id="txtProstitution" name="txtProstitution" className="add-only" />
                        </td>

                        <td className="w-250">
                            <input type="checkbox" id="cbSTI" name="cbSTI_1" className="add-only" value="1" />
                            STI's/STD's/HIV
                            <input type="text" id="txtSTI" name="txtSTI" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbAtRisk" name="cbAtRisk_1" className="add-only" value="1" />
                            At-risk behaviors (unprotected sex):
                            <input type="text" id="txtAtRisk" name="txtAtRisk" className="add-only" />
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbPregnancies" name="cbPregnancies_1" className="add-only" value="1" />
                            Pregnancies:
                            <input type="text" id="txtPregnancies" name="txtPregnancies" className="add-only" />
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbInappropriateBehavior" name="cbInappropriateBehavior1" className="add-only" value="1" />
                            Inappropriate boundaries/behavior:
                            <input type="text" id="txtInappropriate" name="txtInappropriate" className="add-only" />
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className="eleHeader">Sexual Perpetrator</span>
                    <input type="radio" id="rbSexualPerpetrator_Nonereported" name="rbSexualPerpetrator_Nonereported" className="add-only" value="None Reported" /> None Reported &nbsp;
                    <input type="radio" id="rbrbSexual_Specifyintensity" name="rbSexual" className="add-only" value="Specify intensity type date of last incident" /> Specify intensity, type, date of last incident, active charges, history of treatment, current sexual supervision plan (DJJ) &nbsp;
                    <textarea id="txtSexualPerpetrator" name="txtSexualPerpetrator" className="add-only "></textarea>

                </p>

                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader">History of Abuse/Trauma</span>
                            <span className="small block">(explain nature of abuse, individuals involved, legal involvement, outcome, current safety plan in the home, living conditions such as sharing of rooms with victim)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbHistory_Nonereported" name="cbHistory_Nonereported1" className="add-only" value="1" />
                            None Reported
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbSexual" name="cbSexual_1" className="add-only" value="1" />
                            Sexual:
                            <input type="text" id="txtSexuall" name="txtSexuall" className="add-only" />
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbPhysical" name="cbPhysical_1" className="add-only" value="1" />
                            Physical:
                            <input type="text" id="txtPhysical" name="txtPhysical" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbEmotional" name="cbEmotional_1" className="add-only" value="1" />
                            Emotional/Humiliation:
                            <input type="text" id="txtEmotional" name="txtEmotional" className="add-only" />
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbNeglect" name="cbNeglect_1" className="add-only" value="1" />
                            Neglect (emotional, nutritional, educational, medical):
                            <input type="text" id="txtNeglect" name="txtNeglect" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbDomestic" name="cbDomestic_1" className="add-only" value="1" />
                            Domestic Violence (witness or victim):
                            <input type="text" id="txtDomestic" name="txtDomestic" className="add-only" />
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbWitness" name="cbWitness_1" className="add-only" value="1" />
                            Witness to abuse:
                            <input type="text" id="txtWitness" name="txtWitness" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="checkbox" id="cbTrauma" name="cbTrauma_1" className="add-only" value="1" />
                            Trauma (deaths, separation from family, violence, war, natural disaster, etc):
                            <input type="text" id="txtTrauma" name="txtTrauma" className="add-only" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">Risky Behaviors</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbShoplifting" name="cbShoplifting1" className="add-only" value="1" />
                            Shoplifting
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbRecklessDriving" name="cbRecklessDriving1" className="add-only" value="1" />
                            Reckless Driving
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbGang" name="cbGang" className="add-only" value="1" />
                            Gang Involvement
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbDrugDealing" name="cbDrugDealing1" className="add-only" value="1" />
                            Drug Dealing
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbWeaponPossession" name="cbWeaponPossession1" className="add-only" value="1" />
                            Weapon Possession
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbRisk_Other" name="cbRisk_Other1" className="add-only" value="1" />
                            Other:
                            <input type="text" id="txtRisk_Other" name="txtRisk_Other" className="add-only" />
                        </td>
                    </tr>
                </table>
                <span className="small block">Explain if Checked</span>
                <textarea id="txtExplainIfChecked" name="txtExplainIfChecked" className="add-only "></textarea>

                <h4>Developmental History</h4>
                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">Pregnancy</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="radio" id="rbPlanned" name="rbPregnancy" className="add-only" value="Planned" />
                            Planned
                        </td>
                        <td className="w-250">
                            <input type="radio" id="rbUnplanned" name="rbPregnancy" className="add-only" value="Unplanned" />
                            Unplanned
                        </td>
                        <td className="w-250">
                            <input type="radio" id="rbUnknown" name="rbPregnancy" className="add-only" value="Unknown" />
                            Unknown:
                            <input type="text" id="txtUnknown" name="txtUnknown" className="add-only w-170" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">Delivery</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbFullTerm" name="cbFullTerm_1" className="add-only" value="1" />
                            Full term
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbPremature" name="cbPremature_1" className="add-only" value="1" />
                            Premature, specify months:
                            <input type="text" id="txtPremature" name="txtPremature" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbDelivery_Unknow" name="cbDelivery_Unknow1" className="add-only" value="1" />
                            Unknown:
                            <input type="text" id="txtDelivery_Unknow" name="txtDelivery_Unknow" className="add-only" />
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbComplications" name="cbComplications1" className="add-only" value="1" />
                            Complications:
                            <input type="text" id="txtComplications" name="txtComplications" className="add-only" />
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className="eleHeader">Drug/Alcohol use during pregnancy</span>
                    <input type="radio" id="rbDrug_None" name="rbDrug" className="add-only" value="None Reported" /> None Reported &nbsp;
                    <input type="radio" id="rbDrug_Specify" name="rbDrug" className="add-only" value="Specify" /> Specify &nbsp;
                    <textarea id="txtDrug_Specify" name="txtDrug_Specify" className="add-only "></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Developmental Milestones</span>
                    <span className="small block">(walking, toilet training, speech development)</span>
                    <input type="radio" id="rbDevelopmental_Average" name="rbDevelopmental" className="add-only" value="Average" /> Average &nbsp;
                    <input type="radio" id="rbDevelopmental_Slow" name="rbDevelopmental" className="add-only" value="Slow" /> Slow &nbsp;
                    <input type="radio" id="rbDevelopmental_Advanced" name="rbDevelopmental" className="add-only" value="Advanced" /> Advanced &nbsp;
                    <input type="radio" id="rbDevelopmental_Unknown" name="rbDevelopmental" className="add-only" value="Unknown" /> Unknown &nbsp;
                    <textarea id="txtDevelopmentalMilestones" name="txtDevelopmentalMilestones" className="add-only "></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Learning Disorders/ Developmental Disorders</span>
                    <span className="small block">(reading, MR, Motor Skills Disorders, Communication Disorders, Speech, Autism)</span>
                    <input type="radio" id="rbLearning_Nonereported" name="rbLearning" className="add-only" value="None Reported" /> None Reported &nbsp;
                    <input type="radio" id="rbLearning_Past" name="rbLearning" className="add-only" value="Past" /> Past &nbsp;
                    <input type="radio" id="rbLearning_Current" name="rbLearning" className="add-only" value="Current" /> Current &nbsp;
                    <textarea id="txtLearning" name="txtLearning" className="add-only "></textarea>

                </p>

                <h3>Relationships/Social/Peer Interaction
                </h3>
                <p className="w-750">
                    <span className="eleHeader">Describe relationship with siblings</span>
                    <textarea id="txtSiblingsRelationship" name="txtSiblingsRelationship" className="add-only "></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Describe peer relationships</span>
                    <span className="small block">(same sex and opposite-sex relationships)</span>
                    <textarea id="txtPeerRelationships" name="txtPeerRelationships" className="add-only "></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Support System</span>
                    <textarea id="txtSupportSystem" name="txtSupportSystem" className="add-only "></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Education History</span>
                    <span className="small block">Include history of schools attended; any retentions/grade(s); special services i.e. SST or Speech; general conduct,
                        relationships with authority and peers; academic goals and attendance trends; extra-curriculum activities; present school)</span>

                </p>



                <table>
                    <tr>
                        <td className="w-250">
                            <input type="radio" id="rbMainstream" name="rbSchool" className="add-only" value="Mainstream School" />
                            Mainstream School
                        </td>
                        <td className="w-250">
                            <input type="radio" id="rbAlternative" name="rbSchool" className="add-only" value="Alternative School" />
                            Alternative School
                        </td>
                        <td className="w-250">
                            <input type="radio" id="rbPsychoeducational" name="rbSchool" className="add-only" value="Psychoeducational Program" />
                            Psycho-educational Program
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="radio" id="rbOutSchool" name="rbSchool" className="add-only" value="Alternative School" />
                            Out of school
                        </td>
                        <td className="w-250">
                            <input type="radio" id="rbHomeSchool" name="rbSchool" className="add-only" value="Psychoeducational Program" />
                            Home School
                        </td>
                    </tr>
                </table>
                <textarea id="txtEducationHistory" name="txtEducationHistory" className=" add-only"></textarea>

                <table>
                    <tr>
                        <td className="w-350">
                            <span className="eleHeader"># of school absences within the last 30 days</span>
                            <input type="text" id="txtSchoolAbsences" name="txtSchoolAbsences" className="add-only _240" />
                        </td>
                        <td className="w-200">
                            <span className="eleHeader">Current grade</span>
                            <input type="text" id="txtCurrentGrade" name="txtCurrentGrade" className="add-only _240" />
                        </td>
                        <td className="w-200">
                            <span className="eleHeader">IEP/Special Education</span>
                            <td className="w-50">
                                <input type="radio" id="rbIEP_Yes" name="rbIEP" className="add-only" value="Yes" />
                                Yes
                            </td>
                            <td className="w-150">
                                <input type="radio" id="rbIEP_No" name="rbIEP" className="add-only" value="None Reported" />
                                None Reported
                            </td>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">Intellectual Disabilities</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="radio" id="rbIntellectual_No" name="rbIntellectual" className="add-only" value="None Reported" />
                            None Reported
                        </td>
                        <td className="w-187">
                            <input type="radio" id="rbIntellectual_Yes" name="rbIntellectual" className="add-only" value="yes" />
                            Yes
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    If yes, please explain
                    <textarea id="txtIntellectual" name="txtIntellectual" className=" add-only"></textarea>

                </p>
                <h3>Substance Abuse Assessment</h3>
                <span className="small block">(state "denied" if Individual denied past or current use)</span>
                <table>
                    <tr>
                        <td className="w-170"><span className="eleHeader">Substance Name</span></td>
                        <td className="w-80"><span className="eleHeader">Denied</span></td>
                        <td className="w-50"><span className="eleHeader">Age of 1st Use</span></td>
                        <td className="w-155"><span className="eleHeader">Date of Last Use</span></td>
                        <td className="w-155"><span className="eleHeader">Frequency/Amount</span></td>
                        <td className="w-140"><span className="eleHeader">Longest Period of Sobriety</span></td>
                    </tr>
                    <tr>
                        <td className="w-170">Alcohol</td>
                        <td className="w-80"><center>
                            <input type="checkbox" id="cbSAA_Denied_1" name="cbSAA_Denied_1" className="add-only" value="1" /></center>
                        </td>
                        <td className="w-50">
                            <input type="text" id="txtSAA_Age_1" name="txtSAA_Age_1" className="add-only" />
                        </td>
                        <td className="w-155">
                            <input type="date" id="txtSAA_Date_1" name="txtSAA_Date_1" className="add-only" />
                        </td>
                        <td className="w-155">
                            <input type="text" id="txtSAA_Freq_1" name="txtSAA_Freq_1" className="add-only" />
                        </td>
                        <td className="w-140" >
                            <input type="text" id="txtSAA_Sober_1" name="txtSAA_Sober_1" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-170">Cannabis</td>
                        <td className="w-80"><center>
                            <input type="checkbox" id="cbSAA_Denied" name="cbSAA_Denied_2" className="add-only" value="1" /></center>
                        </td>
                        <td className="w-50">
                            <input type="text" id="txtSAA_Age_2" name="txtSAA_Age_2" className="add-only" />
                        </td>
                        <td className="w-155">
                            <input type="date" id="txtSAA_Date_2" name="txtSAA_Date_2" className="add-only" />
                        </td>
                        <td className="w-155">
                            <input type="text" id="txtSAA_Freq_2" name="txtSAA_Freq_2" className="add-only" />
                        </td>
                        <td className="w-140">
                            <input type="text" id="txtSAA_Sober_2" name="txtSAA_Sober_2" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-170">Cocaine</td>
                        <td className="w-80"><center>
                            <input type="checkbox" id="cbSAA_Denied" name="cbSAA_Denied_3" className="add-only" value="1" /></center>
                        </td>
                        <td className="w-50">
                            <input type="text" id="txtSAA_Age_3" name="txtSAA_Age_3" className="add-only" />
                        </td>
                        <td className="w-155">
                            <input type="date" id="txtSAA_Date_3" name="txtSAA_Date_3" className="add-only" />
                        </td>
                        <td className="w-155">
                            <input type="text" id="txtSAA_Freq_3" name="txtSAA_Freq_3" className="add-only" />
                        </td>
                        <td className="w-140">
                            <input type="text" id="txtSAA_Sober_3" name="txtSAA_Sober_3" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-170">Stimulants</td>
                        <td className="w-80"><center>
                            <input type="checkbox" id="cbSAA_Denied" name="cbSAA_Denied_4" className="add-only" value="1" /></center>
                        </td>
                        <td className="w-50">
                            <input type="text" id="txtSAA_Age_4" name="txtSAA_Age_4" className="add-only" />
                        </td>
                        <td className="w-155">
                            <input type="date" id="txtSAA_Date_4" name="txtSAA_Date_4" className="add-only" />
                        </td>
                        <td className="w-155">
                            <input type="text" id="txtSAA_Freq_4" name="txtSAA_Freq_4" className="add-only" />
                        </td>
                        <td className="w-140">
                            <input type="text" id="txtSAA_Sober_4" name="txtSAA_Sober_4" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-170">Methamphetamine</td>
                        <td className="w-80"><center>
                            <input type="checkbox" id="cbSAA_Denied" name="cbSAA_Denied_5" className="add-only" value="1" /></center>
                        </td>
                        <td className="w-50">
                            <input type="text" id="txtSAA_Age_5" name="txtSAA_Age_5" className="add-only" />
                        </td>
                        <td className="w-155">
                            <input type="date" id="txtSAA_Date_5" name="txtSAA_Date_5" className="add-only" />
                        </td>
                        <td className="w-155">
                            <input type="text" id="txtSAA_Freq_5" name="txtSAA_Freq_5" className="add-only" />
                        </td>
                        <td className="w-140">
                            <input type="text" id="txtSAA_Sober_5" name="txtSAA_Sober_5" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-170">LSD/PCP/Mushrooms</td>
                        <td className="w-80"><center>
                            <input type="checkbox" id="cbSAA_Denied" name="cbSAA_Denied_6" className="add-only" value="1" /></center>
                        </td>
                        <td className="w-50">
                            <input type="text" id="txtSAA_Age_6" name="txtSAA_Age_6" className="add-only" />
                        </td>
                        <td className="w-155">
                            <input type="date" id="txtSAA_Date_6" name="txtSAA_Date_6" className="add-only" />
                        </td>
                        <td className="w-155">
                            <input type="text" id="txtSAA_Freq_6" name="txtSAA_Freq_6" className="add-only" />
                        </td>
                        <td className="w-140">
                            <input type="text" id="txtSAA_Sober_6" name="txtSAA_Sober_6" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-170">Heroine/Methadone</td>
                        <td className="w-80"><center>
                            <input type="checkbox" id="cbSAA_Denied" name="cbSAA_Denied_7" className="add-only" value="1" /></center>
                        </td>
                        <td className="w-50">
                            <input type="text" id="txtSAA_Age_7" name="txtSAA_Age_7" className="add-only" />
                        </td>
                        <td className="w-155">
                            <input type="date" id="txtSAA_Date_7" name="txtSAA_Date_7" className="add-only" />
                        </td>
                        <td className="w-155">
                            <input type="text" id="txtSAA_Freq_7" name="txtSAA_Freq_7" className="add-only" />
                        </td>
                        <td className="w-140">
                            <input type="text" id="txtSAA_Sober_7" name="txtSAA_Sober_7" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-170">Steroids/Cough Syrup</td>
                        <td className="w-80"><center>
                            <input type="checkbox" id="cbSAA_Denied" name="cbSAA_Denied_8" className="add-only" value="1" /></center>
                        </td>
                        <td className="w-50">
                            <input type="text" id="txtSAA_Age_8" name="txtSAA_Age_8" className="add-only" />
                        </td>
                        <td className="w-155">
                            <input type="date" id="txtSAA_Date_8" name="txtSAA_Date_8" className="add-only" />
                        </td>
                        <td className="w-155">
                            <input type="text" id="txtSAA_Freq_8" name="txtSAA_Freq_8" className="add-only" />
                        </td>
                        <td className="w-140" >
                            <input type="text" id="txtSAA_Sober_8" name="txtSAA_Sober_8" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-170">Tobacco</td>
                        <td className="w-80"><center>
                            <input type="checkbox" id="cbSAA_Denied" name="cbSAA_Denied_9" className="add-only" value="1" /></center>
                        </td>
                        <td className="w-50">
                            <input type="text" id="txtSAA_Age_9" name="txtSAA_Age_9" className="add-only" />
                        </td>
                        <td className="w-155">
                            <input type="date" id="txtSAA_Date_9" name="txtSAA_Date_9" className="add-only" />
                        </td>
                        <td className="w-155">
                            <input type="text" id="txtSAA_Freq_9" name="txtSAA_Freq_9" className="add-only" />
                        </td>
                        <td className="w-140">
                            <input type="text" id="txtSAA_Sober_9" name="txtSAA_Sober_9" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-170">Prescription Meds</td>
                        <td className="w-80"><center>
                            <input type="checkbox" id="cbSAA_Denied" name="cbSAA_Denied_10" className="add-only" value="1" /></center>
                        </td>
                        <td className="w-50">
                            <input type="text" id="txtSAA_Age_10" name="txtSAA_Age_10" className="add-only" />
                        </td>
                        <td className="w-155">
                            <input type="date" id="txtSAA_Date_10" name="txtSAA_Date_10" className="add-only" />
                        </td>
                        <td className="w-155">
                            <input type="text" id="txtSAA_Freq_10" name="txtSAA_Freq_10" className="add-only" />
                        </td>
                        <td className="w-140">
                            <input type="text" id="txtSAA_Sober_10" name="txtSAA_Sober_10" className="add-only" />
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className="eleHeader">What consequences has Individual faced as result of drug/alcohol use</span>
                    <span className="small block">(DT's, blackouts, overdose, seizures, medical issues, legal charges, VOP's, family problems, work problems, etc.)</span>
                    <textarea id="txtDrugAlcohalUse" name="txtDrugAlcohalUse" className=" add-only"></textarea>

                </p>
                <h3>Diagnostic Impression (DSM-5/ICD-10)</h3>
                <p className="w-750">
                    <span className="eleHeader">Diagnoses</span>
                    <textarea id="txtDiagnoses" name="txtDiagnoses" className=" add-only"></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Justification of Diagnoses</span>
                    <textarea id="txtJustificationDiagnoses" name="txtJustificationDiagnoses" className=" add-only"></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Co-Occurring Disorder</span>
                    <span className="small block">(more than one diagnosis occurring at the same time)</span>
                    <input type="radio" id="rbDisorder_Yes" name="rbDisorder" className="add-only" value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbDisorder_No" name="rbDisorder" className="add-only" value="No" /> No &nbsp;
                    <textarea id="txtCooccuringDisorder" name="txtCooccuringDisorder" className=" add-only"></textarea>

                </p>
                <h3>SNAP's
                </h3>
                <p className="w-750">
                    <span className="eleHeader">Strengths</span>
                    <textarea id="txtStrengths" name="txtStrengths" className=" add-only"></textarea>

                </p>
                <p className="w-750">

                    <span className="eleHeader">Need</span>
                    <textarea id="txtNeed" name="txtNeed" className=" add-only"></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Abilities</span>
                    <textarea id="txtAbilities" name="txtAbilities" className=" add-only"></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Preferences</span>
                    <textarea id="txtPreferences" name="txtPreferences" className=" add-only"></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Spiritual preferences</span>
                    <textarea id="txtSpiritual" name="txtSpiritual" className=" add-only"></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Cultural Considerations</span>
                    <textarea id="txtCultural" name="txtCultural" className=" add-only"></textarea>

                </p>
                <h3>Individual Goals/Expectations</h3>
                <p className="w-750">
                    (in Individual's words and in order of importance)

                </p>
                <p className="w-750">
                    <span className="eleHeader">Goal #1</span>
                    <textarea id="txtGoal_1" name="txtGoal_1" className=" add-only"></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Goal #2</span>
                    <textarea id="txtGoal_2" name="txtGoal_2" className=" add-only"></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Goal #3</span>
                    <textarea id="txtGoal_3" name="txtGoal_3" className=" add-only"></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Goal #4</span>
                    <textarea id="txtGoal_4" name="txtGoal_4" className=" add-only"></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">IFI Admission Criteria (DBHadd-only Provider Manual)</span>
                    <span className="small block">check all that apply:</span>

                </p>






                <p className="w-750">
                    <input type="checkbox" id="cbIFI" name="cbIFI_1" className="add-only" value="1" />
                    Youth has a diagnosis and duration of symptoms which classify that illness as SED and/or diagnosed Substance
                    Related Disorder
                </p>
                <p className="w-750">
                    <input type="checkbox" id="cbIFI" name="cbIFI_2" className="add-only" value="1" />
                    Youth has received documented services through other services modalities (such as CORE services) and/or
                    exhausted less intensive outpatient services. Treatment at a lower intensity has been attempted or given serious
                    consideration, but the risk factors for out-of-home placement are compelling.
                </p>

                <p className="w-750">
                    <input type="checkbox" id="cbIFI" name="cbIFI_3" className="add-only" value="1" />
                    Youth and/or family have insufficient or severely limited resources or skills necessary to cope with an
                    immediate behavioral health crisis.
                </p>

                <p className="w-750">
                    <input type="checkbox" id="cbIFI" name="cbIFI_4" className="add-only" value="1" />
                    Youth and/or family behavioral health issues are unmanageable in traditional outpatient treatment and require
                    intensive, coordinated clinical and supportive intervention.
                </p>

                <p className="w-750">
                    <input type="checkbox" id="cbIFI" name="cbIFI_5" className="add-only" value="1" />
                    Because of behavioral health issues, the youth is at immediate risk of out-of-home placement or is currently in
                    out-of-home placement and reunification is imminent (therefore, intensive work needs to begin with the youth and family regarding the youth's treatment goals.)
                </p>

                <p className="w-750">
                    <input type="checkbox" id="cbIFI" name="cbIFI_6" className="add-only" value="1" />
                    Because of behavioral health issues, the youth is at immediate risk of legal system intervention or is currently
                    involved with DJJ for behaviors/issues related to SED and/or the Substance-related disorder.
                </p>
                <p className="w-750">
                    <span className="eleHeader">CORE Admission Criteria (DBHadd-only Provider Manual)</span>
                    <span className="small block">check all that apply:</span>

                </p>
                <p className="w-750">
                    <input type="checkbox" id="cbCORE" name="cbCORE_1" className="add-only" value="1" />
                    Individual is affected by an emotional disturbance or substance related disorder.
                </p>
                <p className="w-750">
                    <input type="checkbox" id="cbCORE" name="cbCORE_2" className="add-only" value="1" />
                    Individual has shown early indications of behaviors that could be disruptive to the community and the
                    family/support system if behavior intensified.
                </p>
                <p className="w-750">
                    <input type="checkbox" id="cbCORE" name="cbCORE_3" className="add-only" value="1" />
                    Individual has shown early indications behaviors/ functional problems that could cause risk of removal from
                    the home if problems intensified.
                </p>
                <p className="w-750">
                    <input type="checkbox" id="cbCORE" name="cbCORE_4" className="add-only" value="1" />
                    Individual has shown early indications of poor school performance (poor grades, disruptive behavior, lack of
                    motivation, suspension).
                </p>
                <p className="w-750">
                    <input type="checkbox" id="cbCORE" name="cbCORE_5" className="add-only" value="1" />
                    Individual has shown early indications of delinquent behaviors that could result in legal system involvement.
                </p>
                <p className="w-750">
                    <input type="checkbox" id="cbCORE" name="cbCORE_6" className="add-only" value="1" />
                    Individual has shown early indications of behavioral/functional problems that could result in multiple agency
                    involvement if problems intensified.
                </p>
                <p className="w-750">
                    <input type="checkbox" id="cbCORE" name="cbCORE_7" className="add-only" value="1" />
                    Individual demonstrates behaviors that are a risk of harm to self, others, or property.
                </p>
                <p className="w-750">
                    <input type="checkbox" id="cbCORE" name="cbCORE_8" className="add-only" value="1" />
                    Individual indicates the need for detoxification services.
                </p>
                <p className="w-750">
                    <span className="eleHeader">Interpretative Summary</span>
                    <span className="small block">(Include an analysis of the Individual's symptoms; Individual's perception of his/her need for services,
                        interventions that Georgia Health Partners, LLC can offer and community-based needs; include psychological recommendations, diagnosis
                        information and criteria met, identify whether Individual meets IFI or CORE criteria, and concluding statement)</span>
                    <textarea id="txtInterpretativeSummary" name="txtInterpretativeSummary" className=" add-only"></textarea>

                </p>
                <p className="w-750">
                    <span className="eleHeader">Discharge Plan/Transition Plan</span>
                    <textarea id="txtDischargePlan" name="txtDischargePlan" className=" add-only"></textarea>

                </p>



                <table>
                    <span className="eleHeader">Date of Planned Discharge</span>
                    <input type="date" id="txtDatePlanned" name="txtDatePlanned" className="w-250 add-only" />

                    <td className="w-375;">&nbsp;</td>
                </table>
                <p className="w-750">
                    <span className="eleHeader">Barriers to Discharge</span>
                    <span className="small block">(such as compliance, ready for change, etc)</span>
                    <textarea id="txtBarriesDischarge" name="txtBarriesDischarge" className=" add-only"></textarea>

                </p>

                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">Recommendation for step-down services</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbCSI" name="cbCSI_1" className="add-only" value="1" />
                            CSI
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbIndividualTherapy" name="cbIndividualTherapy1" className="add-only" value="1" />
                            Individual Therapy
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbFamilyTherapy" name="cbFamilyTherapy1" className="add-only" value="1" />
                            Family Therapy
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbSubstanceAbuse" name="cbSubstanceAbuse1" className="add-only" value="1" />
                            Substance Abuse Counseling
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbMedication" name="cbMedication1" className="add-only" value="1" />
                            Medication Management:
                            <input type="text" id="txtMedication" name="txtMedication" className="add-only w-170;" />
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbPrivate" name="cbPrivate1" className="add-only" value="1" />
                            Private Physician:
                            <input type="text" id="txtPrivate" name="txtPrivate" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbGroups" name="cbGroups_1" className="add-only" value="1" />
                            Groups (specify):
                            <input type="text" id="txtGroups" name="txtGroups" className="add-only" />
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbMentorProgram" name="cbMentorProgram1" className="add-only" value="1" />
                            Mentor Program
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="checkbox" id="cbOther_Specify" name="cbOther_Specify1" className="add-only" value="1" />
                            Other (specify):
                            <input type="text" id="txtOther_Specify" name="txtOther_Specify" className="add-only" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">Recommendation for Social Support/Community Resources</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbVocational" name="cbVocational1" className="add-only" value="1" />
                            Vocational
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbNutrition" name="cbNutrition1" className="add-only" value="1" />
                            Nutrition/Food Bank
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbDentist" name="cbDentist1" className="add-only" value="1" />
                            Dentist
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbMedical" name="cbMedical_1" className="add-only" value="1" />
                            Medical/PCP
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbVision" name="cbVision_1" className="add-only" value="1" />
                            Vision
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbLeisure" name="cbLeisure_1" className="add-only" value="1" />
                            Leisure
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbGroupssupport" name="cbGroupssupport1" className="add-only" value="1" />
                            Groups/Support Groups
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbMentorPrograms" name="cbMentorPrograms1" className="add-only" value="1" />
                            Mentor Program
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbPlannedParethood" name="cbPlannedParethood1" className="add-only" value="1" />
                            Planned Parenthood/Gynecology
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbSocial_Other" name="cbSocial_Other1" className="add-only" value="1" />
                            Other (specify):
                            <input type="text" id="txtSocial_Other" name="txtSocial_Other" className="add-only" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className="eleHeader">Signature and Date</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-600 signature"></td>
                        <td className="w-150 signature"></td>
                    </tr>
                    <tr>
                        <td className="small w-600">Signature of Assessor</td>
                        <td className="small w-150 "> Date</td>
                    </tr>
                    <tr>
                        <td className="w-750 signature"></td>
                    </tr>
                    <tr>
                        <td className="w-750 small"  >Assessor Name and Credentials</td>
                    </tr>
                </table>

            </div>
        </form>
    )
}